import FormattedPolicyFrame from './FormattedPolicyFrame'

export default FormattedPolicyFrame
